import { Status, Wrapper } from '@googlemaps/react-wrapper'
import { MapComponent } from 'components/shared/MapComponent'
import { Spinner } from 'components/shared/Spinner'
import { FC, ReactElement } from 'react'

export const GoogleMapSection: FC<{ address: string }> = ({ address }) => {
  return (
    <Wrapper
      apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY || ''}
      render={(status: Status): ReactElement => {
        if (status === Status.LOADING) return <Spinner />
        return (
          <MapComponent
            address={address}
            style={{ width: '100%', height: 262 }}
          />
        )
      }}
    />
  )
}
